import { Injectable } from '@angular/core';
import { ApiService } from './helpers/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiResourcesV1 } from './helpers/api-resources';
import { Message } from '../interfaces/message.interface';
import { ChatType } from '../enums/chat-type.enum';
import { MessageType } from '../enums/message-type.enum';

@Injectable()
export class MessagesService {
  constructor(private http: ApiService) {
  }

  getMessageTypes() {
    return {
      [ChatType.CHAT]: MessageType.OPEN_CHAT,
      [ChatType.FORUM]: MessageType.OPEN_FORUM,
      [ChatType.MESSAGE_HUB]: MessageType.TEAM_CHAT,
    };
  }

  getMessages(id, data: any): Observable<Message[]> {
    return this.http.get(`${apiResourcesV1.sessions}/${id}/chat_messages`, data)
      .pipe(map((res: any) => {
        return res.data;
      }));
  }

  addMessage(id, data): Observable<Message> {
    return this.http.post(`${apiResourcesV1.sessions}/${id}/chat_messages`, data)
      .pipe(map((res: any) => {
        return res.data;
      }));
  }

  updateMessage(sessionId, id, data): Observable<Message> {
    return this.http.put(`${apiResourcesV1.sessions}/${sessionId}/chat_messages/${id}`, data)
      .pipe(map((res: any) => {
        return res.data;
      }));
  }

  deleteMessage(sessionId, id): Observable<any> {
    return this.http.delete(`${apiResourcesV1.sessions}/${sessionId}/chat_messages/${id}`)
      .pipe(map((res: any) => {
        return res;
      }));
  }
}
